module.exports = __webpack_public_path__ + "img/chili_oil.55a14ad7.jpg";